import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../zodios/client";

/**
 * Hook for authenticating with KikReach via SSO.
 * Returns an auth_code that can be used to redirect the user to KikReach.
 */
export const useKikReachLogin = () => {
  return useMutation({
    mutationFn: async () => {
      return await apiClient.kikReachLogin(undefined);
    },
  });
};
